import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Loading = ({ type = '' }) => {
    let aditionalClass = '';
    if(type !== '') aditionalClass = `submit-color-${type}`;
    return (
        <div className={"submit--loading "+aditionalClass}></div>
    )
};

Loading.propTypes = {
    type: PropTypes.string
};
export default Loading;
